import React from 'react';
import { Box } from '@mui/material';
import ResponsiveLayout from '../ResponsiveLayout';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { LoaderCore } from './LoaderCore';

export interface LoaderProps {
  text: string;
  mode?: 'determinate' | 'indeterminate';
  progress?: number; // 0-100, only used in determinate mode
  speed?: number; // Animation speed multiplier
  showHeaderFooter?: boolean; // Whether to show header/footer
  isMenuInitialized?: boolean;
}

/**
 * Full-screen loader component that displays either a star-based or standard progress indicator
 * based on the tenant context. Automatically handles header/footer rendering.
 */
export const Loader: React.FC<LoaderProps> = ({
  text,
  mode = 'indeterminate',
  progress = 0,
  speed = 1,
  showHeaderFooter = true,
  isMenuInitialized = false,
}) => {
  const content = (
    <ResponsiveLayout>
      <Box sx={{ width: 300, maxWidth: '90%' }}>
        <LoaderCore text={text} mode={mode} progress={progress} speed={speed} />
      </Box>
    </ResponsiveLayout>
  );

  if (!showHeaderFooter) {
    return content;
  }

  return (
    <>
      <Header isMegaMenuLoaded={isMenuInitialized} />
      {content}
      <Footer />
    </>
  );
};

// Default export for convenience
export default Loader;
